import { BehaviorSubject } from 'rxjs';

export const isLoading$ = new BehaviorSubject(true);

export const getIsLoading$ = () => isLoading$;

export const setIsLoading$ = (value: boolean) => isLoading$.next(value);
